import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative border-b-2 border-zbr-gray-700 group" }
const _hoisted_2 = { class: "w-full mb-2 text-zbr-gray-400 font-oswald group-hover:placeholder:text-zbr-primary" }
const _hoisted_3 = { class: "flex flex-row justify-around mb-6" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 0,
  class: "relative text-center py-10"
}
const _hoisted_6 = { class: "w-auto h-7 mr-6 object-contain grayscale transition-all duration-300 group-hover:grayscale-0" }
const _hoisted_7 = { class: "text-sm pl-4" }

import IconAdd from '@/components/icons/IconAdd.vue';
import Loading from 'vue3-loading-overlay/dist/index';
import VehicleSearchBox from '@/components/VehicleSearchBox.vue';
import VehicleSearchSelectList from '@/components/VehicleSearchSelectList.vue';

import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useVehicleSearchStore } from '@/stores/useVehicleSearchStore';
import { usePromise, UsePromiseResult} from '@/composables/usePromise';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchByManufacturers',
  setup(__props) {

const router = useRouter();
const vehicleStore = useVehicleSearchStore();
const { allManufacturers } = storeToRefs(vehicleStore);

// Computed
const getManufacturerItems = computed(() => {
  return allManufacturers.value.slice().map((item) => {
    return {
      label: item.name,
      value: item.key,
    };
  });
});

const getTopManufacturers = computed(() => {
  const onlyTopManufacturers = allManufacturers.value.slice().filter((val) => val.isFavorite);
  return onlyTopManufacturers;
});

// Methods
function onSelectItem({ label, value }: { label: string, value: string }) {
  router.push({
    name: 'vehicle-search_manufacturer',
    query: {
      manufacturer: label,
      key: value,
    },
  });
}

const allManufacturerPromise = ref<UsePromiseResult>();
if (allManufacturers.value.length == 0) {
  allManufacturerPromise.value = usePromise(vehicleStore.getAllManufacturers());
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createBlock(VehicleSearchBox, {
    title: _ctx.$t('BIKES-SEARCH-MANUFACTURER-1')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('TOP-BRAND')), 1),
        _createVNode(_component_router_link, {
          to: {
          name: 'your-data',
          query: {
            tab: 'favorite'
          }
        },
          class: "absolute right-0 top-0 pl-3 border-l-2 border-zbr-gray-200"
        }, {
          default: _withCtx(() => [
            _createVNode(IconAdd, { "class-stroke": "stroke-zbr-gray-400 group-hover:stroke-zbr-primary" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTopManufacturers.value, (topBrand, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: `topBrand${index}`,
            to: { name: 'vehicle-search_manufacturer', query: { manufacturer: topBrand.name, key: topBrand.key } },
            class: "block w-[60px] h-[60px] flex justify-center items-center grayscale transition-all duration-300 hover:grayscale-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "w-auto h-10 object-contain",
                src: `https://cdn.jfnet.de/bikeLogos/${topBrand.name.toLowerCase().replace(/[^A-Z0-9]/ig, '')}/100x100-cc-xxxxxx.png`,
                alt: topBrand.name
              }, null, 8, _hoisted_4)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _createVNode(_Transition, {
        mode: "out-in",
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition ease-in duration 100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (allManufacturerPromise.value && allManufacturerPromise.value.isPending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(Loading), {
                  color: "var(--color-primary)",
                  "is-full-page": false,
                  width: 30,
                  height: 30,
                  active: ""
                })
              ]))
            : (_openBlock(), _createBlock(VehicleSearchSelectList, {
                key: 1,
                items: getManufacturerItems.value,
                "search-placeholder": _ctx.$t(_ctx.$t('SEARCH-ALL-BRAND')),
                "max-height": "calc(100% - 155px)",
                "has-search": "",
                "highlight-search": "",
                "is-custom-list-item": "",
                onSelectItem: onSelectItem
              }, {
                "list-item": _withCtx(({ item }) => [
                  _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                    [_directive_lazy, `https://cdn.jfnet.de/bikeLogos/${item.label.toLowerCase().replace(/[^A-Z0-9]/ig, '')}/100x100-cc-xxxxxx.png`]
                  ]),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1)
                ]),
                _: 1
              }, 8, ["items", "search-placeholder"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})